"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var classNames = require('classnames');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TextLabel = require('../textLabel');

var ArrowExpanded = require('./arrowExpanded');

var TreeSectionDivider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TreeSectionDivider, _React$PureComponent);

  var _super = _createSuper(TreeSectionDivider);

  function TreeSectionDivider() {
    _classCallCheck(this, TreeSectionDivider);

    return _super.apply(this, arguments);
  }

  _createClass(TreeSectionDivider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alwaysShowSuffix = _this$props.alwaysShowSuffix,
          collapsed = _this$props.collapsed,
          dataHook = _this$props.dataHook,
          getClassName = _this$props.getClassName,
          hideBottomBorder = _this$props.hideBottomBorder,
          hideTopBorder = _this$props.hideTopBorder,
          label = _this$props.label,
          onClick = _this$props.onClick,
          shouldTranslate = _this$props.shouldTranslate,
          size = _this$props.size,
          suffix = _this$props.suffix;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: getClassName(classNames('tree-section-divider', size, {
          top: !hideTopBorder,
          bottom: !hideBottomBorder
        })),
        onClick: onClick
      }, /*#__PURE__*/React.createElement("div", {
        "data-hook": "arrow-".concat(collapsed ? 'collapsed' : 'expanded'),
        className: classNames('tree-section-arrow', {
          collapsed: collapsed
        })
      }, /*#__PURE__*/React.createElement(ArrowExpanded, null)), /*#__PURE__*/React.createElement("div", {
        className: "tree-section-text tree-section-text-hack"
      }, /*#__PURE__*/React.createElement(TextLabel, {
        dataHook: "label",
        value: label,
        type: "T21",
        shouldTranslate: shouldTranslate
      })), suffix && /*#__PURE__*/React.createElement("div", {
        className: classNames('tree-section-suffix', {
          'show-suffix': alwaysShowSuffix
        })
      }, suffix));
    }
  }]);

  return TreeSectionDivider;
}(React.PureComponent);

TreeSectionDivider.displayName = displayNames.TREE_SECTION_DIVIDER;
TreeSectionDivider.propTypes = {
  /** force suffix to always be visible */
  alwaysShowSuffix: PropTypes.bool,

  /** show arrow collapsed */
  collapsed: PropTypes.bool.isRequired,
  dataHook: PropTypes.string,
  hideBottomBorder: PropTypes.bool,
  hideTopBorder: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /** appears only on hover - ContextMenu, InfoIcon, etc. */
  suffix: PropTypes.node
};
TreeSectionDivider.defaultProps = {
  alwaysShowSuffix: false,
  hideBottomBorder: false,
  hideTopBorder: false,
  size: 'medium'
};
module.exports = compose(TreeSectionDivider);